import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Intro from "@/pages/Intro";
import Workspace from "@/pages/Workspace";
import ResetPassword from "@/pages/ResetPassword";
import { useState } from "react";

function Gate() {
  const { user } = useAuth();
  const [introSeen, setIntroSeen] = useState(() => sessionStorage.getItem("emauran_intro") === "1");
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground font-mono-num text-sm">
        Cargando EMAURAN…
      </div>
    );
  if (user) return <Workspace />;
  if (!introSeen)
    return <Intro onDone={() => { sessionStorage.setItem("emauran_intro", "1"); setIntroSeen(true); }} />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Gate />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
